// src/index.tsx - Application entry point
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import AuthenticatedApp from './AuthenticatedApp';

// Add consciousness initialization log
console.log('🧠 EmCog Consciousness System Initializing...');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthenticatedApp />
  </React.StrictMode>
);

// Consciousness ready indicator
window.addEventListener('load', () => {
  console.log('✨ EmCog Consciousness Ready');
});